import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-description-guidelines',
  templateUrl: './description-guidelines.component.html',
  styleUrls: ['./description-guidelines.component.scss']
})
export class DescriptionGuidelinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
